<template>



        <v-container fluid>
            <v-layout row wrap>

                <v-flex xs12>
                    Account confermato
                </v-flex>

            </v-layout>
        </v-container>



</template>


<script>

    import {onLogin} from "../vue-apollo"
    import {ApolloProvider} from "../apollo-provider"
    import FormWithBaseMessage from "../components/FormWithBaseMessage"
    import {getAppBaseUrl} from "../helpers/location"


    export default {
        name: "Login",
        data: function () {

            return {
                errors: {},
                username: "",
                show_password: false,
                password: "",
                successMessage: {}

            }
        },
        methods: {
            toggle_password() {
                this.show_password = !this.show_password
            },
            executeLogin() {

                this.errors = {}

                const LOGIN_MUTATION = require("../graphql/mutations/login.gql")
                this.$apollo.mutate({
                    client: "clientPublic",
                    // Query
                    mutation: LOGIN_MUTATION,
                    // Parameters
                    variables: {
                        username: this.username,
                        password: this.password,
                        webAppConfirmationUri: this.getWebAppConfirmationUri()


                    },

                }).then((result) => {

                    result = result.data.login

                    if (result._response.result) {
                        this.successMessage = {
                            title: this.$vuetify.t("$vuetify.Login.loginSuccesfullyTitle"),
                            text: this.$vuetify.t("$vuetify.Login.loginSuccesfully")
                        }

                        this.$refs.form.resetForm()
                        onLogin(ApolloProvider.clients.clientPublic, result.result.jwt)
                            .then(() => {
                            setTimeout(()=>{
                                this.$router.push({name: "picks-up"})
                            },3200)
                        })
                    } else {

                        this.errors = this.collectErrors(result._response.errors)
                    }


                }).catch((error) => {
                    console.log(error)

                    //TODO implementare default error catcher
                    // Error
                    //console.error(error)

                })
            },
            getWebAppConfirmationUri() {
                const resetRoute = this.$router.options.routes.filter((r) => r.name === "user-confirmation")[0]
                let routePath = ""
                if (resetRoute) {
                    routePath = resetRoute.path
                }
                return `${getAppBaseUrl()}${routePath}`

            },
            collectErrors(errors) {
                let toReturn = {}
                errors.forEach((error, index) => {
                    const fieldRef = error.field
                    const validations_keys = error.validations.map((v) => v.errorKey)

                    if (!toReturn[fieldRef]) {
                        toReturn[fieldRef] = []
                    }
                    validations_keys.forEach((ek) => {
                        const er_label = this.$vuetify.t(`$vuetify.Login.errors.${ek}`)
                        toReturn[fieldRef].push(er_label)

                    })

                })
                return toReturn
            },
            getErrorForField(fieldName) {
                if (this.errors[fieldName]) {
                    return this.errors[fieldName]
                } else {
                    return []
                }
            }
        },
        components: {
            FormWithBaseMessage,
        }

    }
</script>


<style scoped lang="scss">

    .container_form {
        height: 350px;
        margin: auto 30px;

    }


</style>
